import { render, staticRenderFns } from "./servizi-documenti-casa.vue?vue&type=template&id=cd87bf16"
import script from "./servizi-documenti-casa.vue?vue&type=script&lang=js"
export * from "./servizi-documenti-casa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports